import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Callout/CalloutUsage.mdx";

import Examples from "../../Docs/Components/Callout/CalloutExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Callout"
            description="Display custom, absolutely positioned info using a callout."
            apiSources={["azure-devops-ui/Components/Callout/Callout.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;